export const OPEN_EDIT_WINDOW = 'OPEN_EDIT_WINDOW';
export const CLOSE_EDIT_WINDOW = 'CLOSE_EDIT_WINDOW';
